import {HttpClient} from '@angular/common/http';
import {Injectable, inject} from '@angular/core';
import {Observable} from 'rxjs';
import {BaseDaoService, OrgModelLinkNode} from '@q9elements/ui-kit/common';

@Injectable()
export class LinkedSFNodesService extends BaseDaoService {
  public http = inject(HttpClient);

  public getLinkedSFNode(nodeId: string): Observable<OrgModelLinkNode> {
    const url = `${this.apiUrl}/refmodel/sfnodeInfo/${nodeId}`;

    return this.http.get<OrgModelLinkNode>(url);
  }
}
